module.exports = __webpack_public_path__ + "img/astronaut.507ca066.jpg";